import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import { ref, onMounted, onUnmounted } from "vue";
import { hasConsent } from "~/js/utils/cookie-script";
import { Image } from "~/js/interfaces/media";

import ImageContent from "~/vue/atoms/images/ImageContent.vue";

interface Props {
	image: Image;
	ratio?: string;
	fetchpriority?: string;
	loading?: string;
	utilities?: string;
	categories: Array<string>;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'ConsentVideo',
  props: {
    image: {},
    ratio: { default: "aspect-video" },
    fetchpriority: {},
    loading: {},
    utilities: { default: "" },
    categories: {}
  },
  setup(__props: any) {

const props = __props;

const consentGiven = ref(false);

const updateConsent = () => {
	consentGiven.value = hasConsent(props.categories);
	console.log("Consent video given value: " + hasConsent(props.categories));
};

onMounted(() => {
	updateConsent();
	window.addEventListener("ConsentUpdated", updateConsent);
});

onUnmounted(() => {
	window.removeEventListener("ConsentUpdated", updateConsent);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (__props.image && !consentGiven.value)
      ? (_openBlock(), _createBlock(ImageContent, {
          key: 0,
          utilities: "absolute left-0 top-0 h-full w-full",
          image: __props.image,
          ratio: "w-full h-full !rounded-none",
          loading: __props.loading,
          sizes: ['100vw'],
          fetchpriority: __props.fetchpriority
        }, null, 8, ["image", "loading", "fetchpriority"]))
      : _createCommentVNode("", true),
    (consentGiven.value)
      ? _renderSlot(_ctx.$slots, "default", {}, undefined, undefined, 1)
      : _createCommentVNode("", true)
  ], 64))
}
}

})